import { eventActions } from "../../actionTypes";

const initialState = {
	subcategories: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case eventActions.FETCH_EVENT_SUB_CATEGORIES: {
			return { ...state, fetching: true };
		}

		case eventActions.FETCH_EVENT_SUB_CATEGORIES_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				subcategories: { data: action.payload.data.data[0].sub_categories },
			};
		}

		case eventActions.FETCH_EVENT_SUB_CATEGORIES_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
